import { ActionForm } from '../hooks'

export const getDefaultValue = (): ActionForm => {
  return {
    code: '',
    title: '',
    jsValue: '',
    actionCode: undefined,
    actionTitle: undefined,
    eventTitle: undefined,
    eventCode: null,
    params: '',
    columnToSort: null,
    json: false,
    objectFormCode: null,
    contextMenu: null,
    targetColumn: null,
    formObject: null,
    command: null,
    redefinitionCommands: [],
    variable: null,
    field: null,
  }
}
